// DO NOT UPDATE THIS FILE! This file was auto-generated by generate-keys.ts
export type TranslationsKeys =
  | 'cairo.emptyState.premium.text'
  | 'cairo.customFields.fieldType.shortText'
  | 'cairo.delete.button'
  | 'cairo.deselectAll'
  | 'cairo.table.deleteViewModal.title'
  | 'cairo.table.advanced-sorting.ascending.order'
  | 'cairo.table.custom-columns.indication.user'
  | 'cairo.table.saveViewModal.title'
  | 'cairo.tags.manageTags.modal.list.input.validation.exists.asLabels'
  | 'fields.audio.button.download'
  | 'cairo.customFields.fieldType.numberDecimal.placeholder'
  | 'cairo.tags.popover.tagCreated.toast.success'
  | 'cairo.dragAndDrop.list-aria-label.sr'
  | 'fields.audio.button.add'
  | 'cairo.collectionPage.nested.expandAll.tooltip'
  | 'cairo.customFields.addCustomField.modal.add.CTA'
  | 'cairo.editableTable.time.validation.invalid'
  | 'cairo.import.subtitle'
  | 'cairo.import.progressLabel'
  | 'cairo.import.done'
  | 'cairo.tags.loadTags.error.CTA'
  | 'cairo.appliedFilters.filteredBy.label'
  | 'cairo.toast.retry'
  | 'cairo.filterOperator.greaterThan.tag'
  | 'cairo.emptyState.filters.nothingFound.title'
  | 'cairo.connection.error.text'
  | 'cairo.table.summaryBar.loadError.cta'
  | 'cairo.customFields.archive.modal.description.enabled'
  | 'cairo.tags.tagsWidget.emptyState.body.asLabels'
  | 'cairo.import.restoring'
  | 'cairo.table.saveView.button'
  | 'cairo.import.save'
  | 'cairo.customFields.editCustomField.fieldType.tooltip'
  | 'cairo.import.editField'
  | 'cairo.export.cancelTheExportGoBack'
  | 'cairo.viewDropdown.category.info'
  | 'cairo.setupWidget.error.subtitle'
  | 'cairo.editableTable.contextMenu.selectAll.CTA'
  | 'cairo.customFields.addCustomField.modal.emptyFieldName.error'
  | 'cairo.table.custom-columns.indication.app.tooltip'
  | 'cairo.filtersPanel.numRange.title'
  | 'cairo.export.cancelTheExportConfirm'
  | 'cairo.export.CreateExportAsyncJob.method-endpoint-not-found.error'
  | 'cairo.export.exporting'
  | 'cairo.import.back'
  | 'cairo.export.exportingDescription'
  | 'cairo.manageView.setAsDefault.CTA'
  | 'cairo.customFields.addCustomField.modal.advancedSettings.siteCollaborators'
  | 'cairo.passiveEmptyState.title'
  | 'cairo.filterOperator.valuePlaceholder.tag'
  | 'cairo.emptyState.title'
  | 'cairo.sortableColumns.modal.cancel'
  | 'cairo.customFields.writePermission.tooltip'
  | 'cairo.customFields.manageFields.subtitle'
  | 'cairo.tags.bulkItemUpdate.toast.error.CTA.asLabels'
  | 'cairo.customFields.emptyStatePassive.subtitle'
  | 'cairo.table.custom-columns.indication.system.tooltip'
  | 'cairo.manageView.saveChanges.disabled.predefinedView.tooltip'
  | 'cairo.entityPage.header.subscribe.CTA'
  | 'cairo.setupWidget.error.cta'
  | 'cairo.fieldValidation.required.label'
  | 'cairo.customFields.fieldType.date'
  | 'cairo.tags.collectionPage.tagsColumn.title'
  | 'cairo.emptyState.filters.nothingFound.description'
  | 'cairo.customFields.fieldType.numberInteger.placeholder'
  | 'cairo.appliedFilters.applyAndClose.CTA'
  | 'cairo.table.saveViewModal.nameLabel'
  | 'cairo.archivedFields.rmore-actions.restore'
  | 'cairo.customFields.editCustomField.modal.title'
  | 'cairo.editableTable.contextMenu.copy.CTA'
  | 'cairo.editableTable.row.invalidCells.tooltip'
  | 'cairo.disabled'
  | 'cairo.editableTable.contextMenu.cut.CTA'
  | 'cairo.tags.manageTags.modal.toast.rename.success.asLabels'
  | 'cairo.tags.bulkItemUpdate.toast.error.CTA'
  | 'cairo.export.databaseIssueMessage'
  | 'cairo.tags.manageTags.modal.toast.create.error.asLabels'
  | 'cairo.picker.itemsSelected.maxSelected.tooltip'
  | 'cairo.import.noRowsFound'
  | 'cairo.customFields.fieldType.dropdownList.addOption.CTA'
  | 'cairo.editableTable.color.ariaLabel.picker'
  | 'cairo.dragAndDrop.leaveSite.modal.cancel.CTA'
  | 'cairo.tags.manageTags.modal.deleteModal.delete.CTA'
  | 'cairo.updatedView.collectionPage.toast.cta'
  | 'cairo.editableTable.dateTime.placeholder.hour'
  | 'cairo.customFields.addCustomField.modal.PII-setting.toggle.createNote'
  | 'cairo.tags.popover.assignFolder.tooltip'
  | 'cairo.editableTable.dateTime.placeholder.month'
  | 'cairo.archivedFields.more-actions.tooltip'
  | 'cairo.customFields.fieldType.dropdownList.placeholder'
  | 'cairo.editableTable.dateTime.placeholder'
  | 'cairo.filtersPanel.numRange.maxRange.error'
  | 'cairo.import.fileReadFailed'
  | 'cairo.setupWidget.step.inProgress'
  | 'cairo.import.idCollisionLabel'
  | 'cairo.errorHandler.requestID.tooltip.cta'
  | 'cairo.tags.manageTags.modal.deleteModal.cancel.CTA'
  | 'cairo.dragAndDrop.discardChanges.CTA'
  | 'cairo.setupWidget.title'
  | 'cairo.table.manage-fields.subtitle'
  | 'cairo.customFields.fieldType.dateAndTime.invalid.value'
  | 'cairo.export.overloadErrorMessage'
  | 'cairo.import.discardChanges.cancel'
  | 'cairo.setupWidget.allComplete.subtitle'
  | 'cairo.table.custom-columns.dragAndDrop.subtitle'
  | 'cairo.customFields.addCustomField.modal.emptyFieldType.error'
  | 'cairo.filterOperator.notContains.tag'
  | 'cairo.filtersPanel.date.today'
  | 'cairo.tags.manageTags.modal.toast.create.error'
  | 'cairo.tags.tagsField.readOnly.emptyState'
  | 'cairo.customFields.fieldType.longText.Name.placeholder'
  | 'cairo.table.layout.table'
  | 'cairo.customFields.fieldType.dropdownList'
  | 'cairo.customFields.archive.modal.cancel.CTA'
  | 'cairo.table.custom-columns.indication.system'
  | 'cairo.emptyState.additem.text'
  | 'cairo.filterOperator.notExists'
  | 'cairo.filtersPanel.time.title'
  | 'cairo.tags.manageTags.modal.list.input.validation.exists'
  | 'cairo.editableTable.duplicateItem.success.toast'
  | 'cairo.customFields.restore.error.toast.CTA'
  | 'cairo.filtersPanel.date.next7Days'
  | 'cairo.sortableColumns.notification.undo'
  | 'cairo.filtersPanel.saveView.button'
  | 'cairo.dragAndDrop.leaveSite.modal.title'
  | 'cairo.import.discardChanges.description'
  | 'cairo.tags.manageTags.modal.search.placeholder'
  | 'cairo.fieldValidation.required.tooltip'
  | 'cairo.export.GetExportAsyncJob.job-not-found.error'
  | 'fields.audio.more_actions_tooltip'
  | 'cairo.editableTable.dateTime.placeholder.day'
  | 'cairo.replace-image.tooltip'
  | 'cairo.tags.filterPanel.dropdown.title.asLabels'
  | 'cairo.editableTable.retry.toast.CTA'
  | 'cairo.filtersPanel.search.clearButton'
  | 'cairo.customFields.fieldType.dateAndTime'
  | 'cairo.search.Tab.noresults.text'
  | 'cairo.viewDropdown.unsavedView.status'
  | 'cairo.technical.error.text'
  | 'cairo.import.downloadFailedRows'
  | 'cairo.export.get-async-job.error.internal'
  | 'cairo.table.advanced-sorting.subtitle'
  | 'cairo.customFields.updateDataExtension.removing-fields-not-allowed.error'
  | 'cairo.customFields.showAll.button'
  | 'cairo.customFields.successToast'
  | 'cairo.customFields.addCustomField.modal.subtitle.note'
  | 'cairo.entityPage.widgetError.TPAconnectionFail.CTA'
  | 'cairo.dragAndDrop.error.toast'
  | 'cairo.table.custom-columns.subtitle'
  | 'cairo.customFields.addCustomField.modal.advancedSettings.read'
  | 'cairo.filterOperator.equals'
  | 'cairo.editableTable.dateTime.ariaLabel.time'
  | 'cairo.customFields.fieldType.dateAndTime.Name.placeholder'
  | 'cairo.customFields.addCustomField.modal.PII'
  | 'cairo.dragAndDrop.reorderMode.toolbar.title.learnMore'
  | 'cairo.dragAndDrop.reorderMode.toolbar.title'
  | 'cairo.tags.manageTags.modal.list.input.placeholder.asLabels'
  | 'cairo.customFields.addCustomField.modal.cancel.CTA'
  | 'cairo.customFields.addCustomField.modal.advancedSettings.siteVisitors.note'
  | 'cairo.import.configureMappingsTitle'
  | 'cairo.editableTable.duplicateItem.error.toast'
  | 'cairo.tags.popover.assignFolder.tooltip.asLabels'
  | 'cairo.deleteModal.title'
  | 'cairo.customFields.fieldType.checkbox.Selected.notChecked'
  | 'cairo.setupWidget.allComplete.title'
  | 'cairo.customFields.booleanValue.true'
  | 'cairo.tags.manageTags.modal.list.action.delete.CTA'
  | 'cairo.customFields.addCustomField.modal.advancedSettings.key.tooltip'
  | 'cairo.filtersPanel.dateRange.title'
  | 'section.header.folders'
  | 'cairo.tags.manageTags.modal.list.input.save.CTA'
  | 'cairo.filterOperator.greaterThanOrEqual'
  | 'cairo.subtitle.learnMore'
  | 'cairo.table.saveViewModal.placeholder'
  | 'cairo.filtersPanel.date.7days'
  | 'cairo.customFields.fieldType.longText.placeholder'
  | 'cairo.customFields.addCustomField.modal.fieldName'
  | 'cairo.editableTable.dateTime.placeholder.minute'
  | 'cairo.filterOperator.startsWith.tag'
  | 'cairo.tags.tagsWidget.subtitle.asLabels'
  | 'cairo.tags.loadTags.error.title'
  | 'cairo.tags.bulkItemUpdate.updatingTags.toast.CTA'
  | 'cairo.manageView.Delete.CTA.error.toast'
  | 'cairo.provider-not-found.error'
  | 'cairo.import.skipColumn'
  | 'cairo.dragAndDrop.reorder-cancelled.sr'
  | 'cairo.appliedFilters.discardChanges.description'
  | 'cairo.customFields.addCustomField.modal.advancedSettings.write'
  | 'cairo.archivedFields.more-actions.delete'
  | 'cairo.pickerModal.back.button'
  | 'cairo.customFields.deleted.undo.CTA'
  | 'cairo.manageView.Delete.disabled.predefinedView.tooltip'
  | 'cairo.import.genericError'
  | 'cairo.tags.manageTags.modal.toast.delete.success'
  | 'cairo.noViewName.validationTooltip'
  | 'cairo.filtersPanel.date.lastMonth'
  | 'cairo.dragAndDrop.reorderMode.toolbar.cancel.cta'
  | 'cairo.table.advanced-sorting.disabled.cta.tooltip'
  | 'cairo.tags.collectionPage.toast.create.error'
  | 'cairo.confirmModal.title'
  | 'cairo.entityPage.header.connect.CTA'
  | 'cairo.customFields.url-input.placeholder'
  | 'cairo.import.stepper.matchFields'
  | 'cairo.customFields.fieldType.time.inputTitle'
  | 'cairo.manageView.Rename.disabled.tooltip'
  | 'cairo.dropdownSearch.select.filers.clear'
  | 'cairo.customFields.addCustomField.modal.advancedSettings.siteVisitors'
  | 'cairo.editableTable.contextMenu.addRowAbove.CTA'
  | 'cairo.tags.manageTags.modal.toast.create.success'
  | 'cairo.search.filter.Tab.noresults.text'
  | 'cairo.table.layout.grid'
  | 'cairo.saveViewModal.saveButton'
  | 'cairo.tags.bulkItemUpdate.toast.success.asLabels'
  | 'cairo.table.custom-columns.move.disabled.tooltip'
  | 'cairo.moreActions'
  | 'cairo.viewDropdown.allOrders.defaultViews'
  | 'cairo.viewsDropdown.nothingMatches.text'
  | 'cairo.customFields.addCustomField.modal.advancedSettings.readPermissions.tooltip'
  | 'cairo.import.importing'
  | 'cairo.manageView.CTA'
  | 'cairo.tags.manageTags.modal.toast.rename.error.asLabels'
  | 'cairo.filtersPanel.header'
  | 'cairo.import.error.submitFailed'
  | 'cairo.fieldValidation.charactersLimit.tooltip'
  | 'cairo.emptyState.filters.nothingFound.clearFilters.CTA'
  | 'cairo.toolbar.moreFiltersButton'
  | 'cairo.export.exportFailedMessage'
  | 'cairo.tags.bulkItemUpdate.updatingModal.title'
  | 'cairo.customFields.fieldType.date.inputTitle'
  | 'cairo.customFields.fieldType.longText'
  | 'cairo.export.tryAgain'
  | 'cairo.filterOperator.notEquals'
  | 'cairo.customFields.addCustomField.modal.PII-setting.toggle.name'
  | 'cairo.customFields.delete.modal.cancel.CTA'
  | 'cairo.dragAndDrop.leaveSite.modal.description'
  | 'cairo.export.allItems'
  | 'cairo.import.failureReasonColumn'
  | 'cairo.customFields.addCustomField.modal.advancedSettings'
  | 'cairo.import.downloadCsv'
  | 'cairo.tags.bulkItemUpdate.updatingTags.toast.asLabels'
  | 'cairo.search.noresults.title'
  | 'cairo.import.cancel'
  | 'cairo.tags.applyChanges.toast.success'
  | 'cairo.editableTable.contextMenu.editRow.noPermission.tooltip'
  | 'cairo.setupWidget.allComplete.cta'
  | 'cairo.import.noMappingsTooltip'
  | 'cairo.import.noRowsWarningTitle'
  | 'cairo.customFields.fieldType.numberInteger.Name.placeholder'
  | 'cairo.tags.popover.bulkItemUpdate.tooltip.asLabels'
  | 'cairo.import.columnsFound'
  | 'cairo.customFields.updateDataExtension.fqdn-not-found.error'
  | 'cairo.import.updateExistingItems'
  | 'cairo.export.serverErrorMessage'
  | 'cairo.toast.undone'
  | 'cairo.entityPage.header.apply.CTA'
  | 'cairo.picker.createNew.button.tooltip'
  | 'cairo.fieldValidation.charactersLimit.separator'
  | 'cairo.page.loadError.failedState.description'
  | 'fields.audio.button.replace'
  | 'cairo.tags.bulkItemUpdate.updatingModal.CTA'
  | 'cairo.manageView.setAsDefault.reset.CTA'
  | 'cairo.filtersPanel.date.title'
  | 'cairo.manageView.setAsDefault.reset.success.toast'
  | 'cairo.customFieldsWidget.entityPage.title'
  | 'cairo.filtersPanel.date.from.clearButton.ariaLabel'
  | 'cairo.tags.manageTags.modal.toast.delete.success.asLabels'
  | 'cairo.customFields.addCustomField.CTA'
  | 'cairo.customFields.addCustomField.modal.fieldType'
  | 'cairo.filtersPanel.done.button'
  | 'cairo.filtersPanel.numRange.maxRange-to.placeholder'
  | 'cairo.emptyState.subtitle.nothingAvailable'
  | 'cairo.tags.tagsWidget.create.CTA'
  | 'cairo.editableTable.array.validation.invalidSyntax'
  | 'cairo.customFields.addCustomField.modal.keyFormat.error'
  | 'cairo.customFields.addCustomField.modal.title'
  | 'cairo.customFields.updateDataExtension.fqdn-not-extensible.error'
  | 'cairo.dropdownSearch.select.filers.placeholder'
  | 'cairo.manageView.saveChanges.error.toast'
  | 'cairo.tags.collectionPage.tagsColumn.emptyState.body'
  | 'cairo.emptyState.title.nothingAvailable'
  | 'cairo.tags.fqdn-not-found.error.cta'
  | 'cairo.toast.undo'
  | 'cairo.filterOperator.equals.tag'
  | 'cairo.filterOperator.lessThanOrEqual'
  | 'cairo.customFields.fieldType.numberDecimal.Name.placeholder'
  | 'cairo.tags.tagsWidget.title.asLabels'
  | 'EditableTable.fields.no_addresses_found'
  | 'cairo.tags.popover.bulkItemLimit.tooltip'
  | 'cairo.fieldValidation.charactersLimit.maximum.label'
  | 'cairo.tags.filterPanel.dropdown.title'
  | 'cairo.manageView.Rename.error.toast'
  | 'cairo.filtersPanel.date.next3Days'
  | 'cairo.customFields.technical.error.title'
  | 'cairo.editableTable.contextMenu.deleteRows.noPermissionMulti.tooltip'
  | 'cairo.table.saveViewModal.body'
  | 'cairo.customFields.emptyStatePassive.title'
  | 'cairo.tags.tagsWidget.options.manage.CTA.asLabels'
  | 'cairo.import.stepper.upload'
  | 'cairo.customFields.entityPage.title'
  | 'cairo.dragAndDrop.reorderMode.toolbar.save.cta'
  | 'cairo.customFields.archive.modal.title'
  | 'cairo.table.deleteViewModal.deleteButton'
  | 'cairo.import.noRowsWarningDescription'
  | 'cairo.export.offlineMessage'
  | 'cairo.editableTable.email.validation.invalid'
  | 'cairo.setupWidget.error.title'
  | 'cairo.confirm.button'
  | 'cairo.filtersPanel.numRange.minRange.error'
  | 'cairo.table.custom-columns.indication.pii.tooltip'
  | 'cairo.tags.collectionPage.tagsColumn.emptyState.body.asLabels'
  | 'cairo.import.parseFailed'
  | 'cairo.customFields.addCustomField.modal.advancedSettings.key.placeholder'
  | 'cairo.customFields.archive.error.toast.CTA'
  | 'cairo.import.error.jobFailed'
  | 'cairo.tags.manageTags.modal.toast.delete.error.asLabels'
  | 'cairo.manageView.Rename.modal.cancel.CTA'
  | 'cairo.filtersPanel.default.All'
  | 'cairo.tags.manageTags.modal.list.input.validation.noName'
  | 'cairo.tags.collectionPage.popover.manage.CTA'
  | 'cairo.table.advanced-sorting.descending.order'
  | 'cairo.tags.applyChanges.toast.undo.CTA'
  | 'cairo.manageView.Rename.modal.field.title'
  | 'cairo.dragAndDrop.discardChanges.title'
  | 'cairo.import.progressTitle'
  | 'cairo.archivedFields.subtitle'
  | 'cairo.customFields.fieldType.checkbox'
  | 'cairo.tags.tagsWidget.input.placeholder.asLabels'
  | 'cairo.entityPage.header.publish.CTA'
  | 'cairo.filtersPanel.date.custom'
  | 'cairo.customFields.modal.networkError'
  | 'cairo.customFields.manageFields.CTA'
  | 'cairo.collectionsPage.edit.CTA'
  | 'cairo.dragAndDrop.reorderMode.toast.success'
  | 'cairo.editableTable.object.validation.invalidSyntax'
  | 'cairo.customFields.addCustomField.modal.sameKey.error'
  | 'cairo.entityPage.saveError-technical.toast.description'
  | 'cairo.import.summaryFailedHint'
  | 'cairo.import.startImport'
  | 'cairo.customFields.addCustomField.modal.advancedSettings.key.title'
  | 'cairo.customFields.addCustomField.modal.PII-setting.toggle.editNote'
  | 'section.header.items'
  | 'cairo.fieldValidation.requiredField'
  | 'cairo.import.failedTitle'
  | 'cairo.tags.popover.bulkItemUpdate.tooltip'
  | 'cairo.customFields.fieldType.numberInteger'
  | 'airo.tags.collectionPage.popover.emptyState.body.asLabels'
  | 'cairo.folders.showAll.button'
  | 'cairo.fieldValidation.charactersLimit.minimum.label'
  | 'cairo.dragAndDrop.reorderMode.discardChanges.description'
  | 'cairo.editableTable.dateTime.ariaLabel.date'
  | 'cairo.filterOperator.lessThan.tag'
  | 'cairo.tags.tagsWidget.emptyState.body'
  | 'cairo.customFields.fieldType.date.placeholder'
  | 'cairo.table.advanced-sorting.title.tooltip'
  | 'cairo.tags.popover.bulkItemLimit.tooltip.asLabels'
  | 'cairo.appliedFilters.discardChanges.title'
  | 'cairo.viewsDropdown.allItems.label'
  | 'cairo.filtersPanel.date.to.placeholder'
  | 'cairo.manageView.Delete.CTA'
  | 'cairo.page.primary.cta'
  | 'cairo.tags.manageTags.modal.close.CTA'
  | 'cairo.picker.createNew.button'
  | 'cairo.table.advanced-sorting.cta'
  | 'cairo.customFields.modal.maxFieldsError'
  | 'cairo.export.export'
  | 'cairo.tags.manageTags.modal.deleteModal.title.asLabels'
  | 'cairo.customFields.fieldType.dropdownList.Name.placeholder'
  | 'cairo.selectorModal.searchEmptyState.changeFilter.subtitle'
  | 'cairo.tags.collectionPage.add.CTA'
  | 'cairo.tags.loadTags.error.CTA.asLabels'
  | 'cairo.tags.collectionPage.popover.emptyState.body'
  | 'cairo.tags.collectionPage.popover.close.CTA'
  | 'cairo.table.custom-columns.disabled.tooltip'
  | 'cairo.tags.manageTags.modal.search.placeholder.asLabels'
  | 'cairo.page.loadError.failedState.title'
  | 'cairo.customFields.addCustomField.modal.PII-setting.toggle.info'
  | 'cairo.table.custom-columns.section-divider'
  | 'cairo.manageView.saveChanges.CTA'
  | 'cairo.customFields.archive.CTA'
  | 'cairo.tags.tagsWidget.noPermissions.tooltip'
  | 'cairo.customFields.addCustomField.modal.advancedSettings.readPermissions'
  | 'cairo.customFields.maxLimit.modal.description'
  | 'cairo.sortableColumns.modal.CTA'
  | 'cairo.filterOperator.greaterThanOrEqual.tag'
  | 'cairo.filtersPanel.noAppliedFilters.label'
  | 'cairo.dragAndDrop.discardChanges.description'
  | 'cairo.filterOperator.lessThan'
  | 'cairo.filterOperator.contains'
  | 'cairo.tags.fqdn-not-found.error'
  | 'cairo.customFields.fetch.technicalError'
  | 'cairo.filterOperator.isEmpty'
  | 'cairo.tags.filterPanel.dropdown.placeholder.asLabels'
  | 'cairo.editableTable.array.validation.invalidType'
  | 'cairo.customFields.emptyState.title'
  | 'cairo.table.custom-columns.button.cta'
  | 'cairo.customFields.addCustomField.modal.sameName.error'
  | 'cairo.editableTable.dateTime.placeholder.year'
  | 'cairo.filtersPanel.sections.default.title'
  | 'cairo.tags.tagsWidget.input.placeholder'
  | 'cairo.fieldValidation.charactersLimit.maxBelowMin.error'
  | 'cairo.entityPage.widgetError.TPAconnectionFail.description'
  | 'cairo.tags.tagsWidget.subtitle'
  | 'cairo.customFields.archive.modal.CTA'
  | 'cairo.customFields.addCustomField.modal.advancedSettings.siteVisitors.tooltip'
  | 'cairo.customFields.delete.error.toast.CTA'
  | 'cairo.export.exportFailed'
  | 'cairo.export.filteredItems'
  | 'cairo.customFields.addCustomField.modal.subtitle'
  | 'cairo.dragAndDrop.reorderMode.discardChanges.title'
  | 'cairo.customFields.modal.technicalError'
  | 'cairo.dragAndDrop.leaveSite.modal.leave.CTA'
  | 'cairo.dragAndDrop.reorderMode.discardChanges.cancel.CTA'
  | 'cairo.customFields.maxLimit.modal.cta'
  | 'cairo.archivedFields.back.manage-custom-fields.tooltip'
  | 'cairo.table.deleteViewModal.cancelButton'
  | 'cairo.editableTable.cell.validation.notCompatible'
  | 'cairo.clear'
  | 'cairo.import.footerLink'
  | 'cairo.emptyState.subtitle.nothingMatchesCriteria'
  | 'cairo.export.downloadManually'
  | 'cairo.export.cancelButton'
  | 'cairo.entityPage.header.submit.CTA'
  | 'cairo.customFields.fieldType.checkbox.Selected.checked'
  | 'cairo.dragAndDrop.note.learnMore'
  | 'cairo.editableTable.dateTime.validation.invalid'
  | 'cairo.fieldValidation.charactersLimit.label'
  | 'cairo.table.advanced-sorting.remove.button.tooltip'
  | 'cairo.moreFilters'
  | 'cairo.filterOperator.valuePlaceholder'
  | 'cairo.dropdownSearch.filters.noResults'
  | 'cairo.dragAndDrop.reorderMode.discardChanges.applyAndClose.CTA'
  | 'cairo.tags.collectionPage.popover.emptyState.search.placeholder.asLabels'
  | 'cairo.custom-columns.more-actions.tooltip'
  | 'cairo.customFields.editCustomField.fieldKey.tooltip'
  | 'cairo.tags.manageTags.modal.toast.create.success.asLabels'
  | 'cairo.table.advanced-sorting.dragAndDrop.tooltip'
  | 'cairo.filtersPanel.date.14days'
  | 'cairo.emptyState.additem.cta'
  | 'cairo.tags.tagsWidget.noPermissions.tooltip.asLabels'
  | 'fields.audio.button.delete'
  | 'cairo.tags.tagsWidget.create.CTA.asLabels'
  | 'cairo.editableTable.contextMenu.duplicateRow.CTA'
  | 'cairo.filterOperator.label'
  | 'cairo.tags.bulkItemUpdate.updatingTags.toast'
  | 'cairo.customFields.url-input.error'
  | 'cairo.noFiltersApplied.validationTooltip'
  | 'cairo.customFields.placeholder.url'
  | 'cairo.customFields.emptyState.subtitle'
  | 'cairo.tags.collectionPage.popover.loadTags.error.body.asLabels'
  | 'cairo.import.discardChanges.confirm'
  | 'cairo.entityPage.header.activate.CTA'
  | 'cairo.tags.manageTags.modal.list.action.rename.CTA'
  | 'cairo.filtersPanel.date.next30Days'
  | 'cairo.tags.collectionPage.tagsColumn.manage.CTA'
  | 'cairo.selectAll'
  | 'cairo.viewDropdown.category.savedViews'
  | 'cairo.manageView.tooltip'
  | 'cairo.editableTable.contextMenu.paste.CTA'
  | 'cairo.export.exportTypeQuestionTitle'
  | 'cairo.fieldValidation.patternMismatch'
  | 'cairo.page.loadError.failedState.CTA'
  | 'cairo.tags.manageTags.modal.subtitle'
  | 'cairo.customFields.fieldType.shortText.Name.placeholder'
  | 'cairo.import.columnTitle'
  | 'cairo.dragAndDrop.live-region.itemGrabbed.sr'
  | 'cairo.customFields.widget.showMore.button'
  | 'cairo.manageView.Rename.modal.title'
  | 'cairo.tags.collectionPage.tagsColumn.title.asLabels'
  | 'cairo.table.summaryBar.loadError'
  | 'cairo.tags.tagsWidget.title'
  | 'cairo.customFields.entityPage.emptyState.subtitle'
  | 'cairo.archivedFields.title'
  | 'cairo.searchPlaceholder'
  | 'cairo.tags.manageTags.modal.deleteModal.title'
  | 'cairo.customFields.addCustomField.modal.advancedSettings.externalApps.tooltip'
  | 'cairo.emptyState.additem.title'
  | 'cairo.tags.bulkItemUpdate.updatingModal.CTA.asLabels'
  | 'cairo.tags.tagsWidget.options.manage.CTA'
  | 'cairo.table.filter.button'
  | 'cairo.table.custom-columns.indication.app'
  | 'cairo.import.discardChanges.title'
  | 'cairo.tags.collectionPage.popover.emptyState.search.placeholder'
  | 'cairo.emptyState.reset.button'
  | 'cairo.customFields.modal.dropDownlist.option.error'
  | 'cairo.appliedFilters.discardChanges.CTA'
  | 'cairo.tags.bulkItemUpdate.updatingModal.body.asLabels'
  | 'airo.tags.collectionPage.popover.emptyState.body'
  | 'cairo.saveViewModal.error.message.unexpected'
  | 'cairo.collectionPage.appInstall-inContext.moreActions.relatedApps.CTA'
  | 'cairo.table.layout.spreadsheet'
  | 'cairo.import.error.uploadFailed'
  | 'cairo.customFields.entityPage.emptyState.title'
  | 'cairo.remove-image.tooltip'
  | 'cairo.tags.collectionPage.add.CTA.asLabels'
  | 'cairo.export.exportToCSVMessage'
  | 'cairo.manageView.unsaved.tooltip'
  | 'cairo.cancel.button'
  | 'cairo.customFields.widget.showLess.button'
  | 'cairo.manageView.saveChanges.disabled.tooltip'
  | 'cairo.selectorModal.searchEmptyState.subtitle'
  | 'cairo.table.layout.switchLayout'
  | 'cairo.editableTable.contextMenu.addRow.noPermission.tooltip'
  | 'cairo.editableTable.contextMenu.deleteRow.notDeletable.tooltip'
  | 'cairo.table.subtitle.learnMore'
  | 'cairo.table.manage-fields.title'
  | 'cairo.manageView.Rename.modal.save.CTA'
  | 'cairo.customFields.archive.technicalError'
  | 'cairo.errorHandler.requestID.tooltip.cta.copied-success'
  | 'cairo.tags.manageTags.modal.toast.rename.error'
  | 'cairo.dragAndDrop.leaveSiteMessage'
  | 'cairo.table.manage-fields.button.cta'
  | 'cairo.table.advanced-sorting.sortManually.toast'
  | 'cairo.customFields.createDataExtension.invalid-namespace.error'
  | 'cairo.error.contactSupport.cta'
  | 'cairo.tags.loadTags.error.body'
  | 'cairo.table.deleteViewModal.deleteButtonTwo'
  | 'cairo.tags.bulkItemUpdate.updatingModal.title.asLabels'
  | 'cairo.table.saveViewModal.learnMoreLink'
  | 'cairo.editableTable.url.validation.invalid'
  | 'cairo.tags.collectionPage.toast.create.error.asLabels'
  | 'cairo.editableTable.createItem.success.toast'
  | 'cairo.import.processFailed'
  | 'cairo.tags.manageTags.modal.emptyState.title'
  | 'cairo.entityPage.header.cancel.CTA'
  | 'cairo.filterOperator.lessThanOrEqual.tag'
  | 'cairo.filterOperator.isEmpty.tag'
  | 'cairo.dragAndDrop.discardChanges.cancel'
  | 'cairo.filtersPanel.search.placeholder'
  | 'cairo.export.successMessage.downloadLink'
  | 'cairo.tags.bulkItemUpdate.updatingTags.toast.CTA.asLabels'
  | 'cairo.deleteModal.body'
  | 'cairo.export.exportingTitle'
  | 'errorHandler.common-error.networkError'
  | 'cairo.filtersPanel.clear.button'
  | 'cairo.customFields.editCustomField.success.toast'
  | 'matvey.test'
  | 'cairo.editableTable.contextMenu.addRowBelow.CTA'
  | 'cairo.export.cancelTheExport'
  | 'cairo.import.newFieldSuffix'
  | 'cairo.customFields.addCustomField.modal.PII.learnMore'
  | 'cairo.import.uploadButtonLabel'
  | 'cairo.tags.manageTags.modal.list.input.cancel.CTA'
  | 'cairo.filtersPanel.numRange.maxRange-to'
  | 'cairo.filterOperator.in.tag'
  | 'cairo.editableTable.address.validation.invalid'
  | 'cairo.customFields.archive.modal.description'
  | 'cairo.filterOperator.exists.tag'
  | 'cairo.emptyState.premium.title'
  | 'cairo.table.manage-fields.dragAndDrop.subtitle'
  | 'cairo.customFields.delete.modal.delete.CTA'
  | 'cairo.customFields.fieldType.numberDecimal'
  | 'cairo.manageView.saveView.error.toast'
  | 'cairo.table.noFiltersApplied.label'
  | 'cairo.filtersPanel.reset'
  | 'cairo.import.tryAgain'
  | 'cairo.manageView.saveNewView.CTA'
  | 'cairo.tags.collectionPage.popover.manage.CTA.asLabels'
  | 'cairo.import.backupDescription'
  | 'cairo.editableTable.object.validation.invalidType'
  | 'cair.appliedFilters.Apply.CTA'
  | 'cairo.export.noPermissionsCTA'
  | 'cairo.updatedView.collectionPage.toast.desc'
  | 'cairo.search.nothingMatches.text'
  | 'cairo.editableTable.date.validation.invalid'
  | 'cairo.viewDropdown.category.predefinedViews'
  | 'cairo.customFields.fieldType.dropdownList.inputTitle'
  | 'cairo.folders.showLess.button'
  | 'cairo.connection.error.title'
  | 'cairo.filtersPanel.date.tomorrow'
  | 'cairo.import.summaryTitle'
  | 'cairo.filtersPanel.date.none'
  | 'cairo.editableTable.updateItem.error.toast'
  | 'cairo.import.collectionField'
  | 'cairo.saveViewModal.cancelButton'
  | 'cairo.import.encodingFailed'
  | 'cairo.tags.manageTags.modal.subtitle.asLabels'
  | 'cairo.tags.manageTags.modal.emptyState.body.asLabels'
  | 'cairo.table.custom-columns.hidden.disabled.tooltip'
  | 'cairo.import.close'
  | 'cairo.import.createNewField'
  | 'cairo.filtersPanel.header.closeButton.ariaLabel'
  | 'cairo.customFields.updateDataExtension.invalid-namespace.error'
  | 'cairo.filterOperator.startsWith'
  | 'cairo.tags.loadTags.error.title.asLabels'
  | 'cairo.entityPage.saveError-offline.toast.description'
  | 'cairo.customFields.fieldType.Time.placeholder'
  | 'cairo.tags.manageTags.modal.list.input.placeholder'
  | 'cairo.tags.collectionPage.popover.search.placeholder.asLabels'
  | 'cairo.filterOperator.notIn'
  | 'cairo.customFields.fileUpload.download.cta'
  | 'cairo.manageView.Rename.CTA'
  | 'cairo.tags.collectionPage.popover.emptyState.body.asLabels'
  | 'cairo.bulkSelected.withMaxNumber'
  | 'cairo.customFields.updateDataExtension.changing-fields-not-allowed.error'
  | 'cairo.filterOperator.exists'
  | 'cairo.import.footerText'
  | 'cairo.filterOperator.contains.tag'
  | 'cairo.export.cancelMessage'
  | 'cairo.customFields.archive.success.toast'
  | 'cairo.entityPage.header.save.CTA'
  | 'cairo.filterOperator.notIn.tag'
  | 'cairo.search.filter.nothingMatches.text'
  | 'cairo.tags.manageTags.modal.toast.rename.success'
  | 'cairo.customFields.edit.CTA'
  | 'cairo.editableTable.color.validation.invalid'
  | 'cairo.customFields.fieldType.url'
  | 'cairo.filtersPanel.numRange.min-from'
  | 'cairo.tags.bulkItemUpdate.toast.success'
  | 'cairo.customFields.archive.success.toast.CTA'
  | 'cairo.customFields.maxFields'
  | 'cairo.offline'
  | 'cairo.table.custom-columns.dragAndDrop.search-placeholder'
  | 'cairo.filterOperator.in'
  | 'cairo.export.leaveSiteTitle'
  | 'cairo.customFields.editCustomField.save.CTA'
  | 'cairo.editableTable.addItem.CTA'
  | 'cairo.filterOperator.notEquals.tag'
  | 'cairo.customFields.manageFields.title'
  | 'cairo.technical.error.title'
  | 'cairo.customFields.fieldType.shortText.placeholder'
  | 'cairo.tags.manageTags.modal.emptyState.body'
  | 'cairo.selectPlaceholder'
  | 'cairo.tags.popover.tagCreated.toast.success.asLabels'
  | 'cairo.errorHandler.requestID.tooltip.description'
  | 'cairo.table.advanced-sorting.sortByColumns.toast'
  | 'cairo.archivedFields.rmore-actions.delete'
  | 'cairo.continue'
  | 'cairo.filtersPanel.numRange.minRange-from.placeholder'
  | 'cairo.collectionsPage.add.item.CTA'
  | 'cairo.table.custom-columns.indication.primary.tooltip'
  | 'cairo.tags.collectionPage.toast.update.error'
  | 'cairo.tags.bulkItemUpdate.updatingModal.body'
  | 'cairo.archivedFields.more-actions.restore'
  | 'cairo.tags.tagsWidget.add.CTA'
  | 'cairo.table.clearFilters.button'
  | 'cairo.table.gridView'
  | 'cairo.export.selectedItems'
  | 'cairo.filterOperator.notContains'
  | 'cairo.entityPage.success.toast'
  | 'cairo.tags.tagsField.readOnly.emptyState.asLabels'
  | 'cairo.table.custom-columns.button.tooltip'
  | 'cairo.table.advanced-sorting.button.tooltip'
  | 'cairo.picker.itemsSelected.maxSelected.message'
  | 'cairo.export.noPermissionsMessage'
  | 'cairo.dragAndDrop.leaveSiteTitle'
  | 'cairo.customFields.booleanValue.false'
  | 'cairo.manageView.setAsDefault.reset.tooltip'
  | 'cairo.tags.manageTags.modal.list.input.validation.emptyName'
  | 'cairo.editableTable.contextMenu.deleteRow.noPermission.tooltip'
  | 'cairo.customFields.createDataExtension.fqdn-not-found.error'
  | 'cairo.emptyState.subtitle.noFilterResults'
  | 'cairo.tags.collectionPage.toast.update.error.asLabels'
  | 'cairo.tags.manageTags.modal.toast.delete.error'
  | 'cairo.editableTable.number.validation.invalid'
  | 'cairo.table.custom-columns.title'
  | 'cairo.tags.manageTags.modal.add.CTA.asLabels'
  | 'cairo.export.leaveSiteMessage'
  | 'cairo.add-image.tooltip'
  | 'cairo.customFields.maxLimit.modal.title'
  | 'cairo.manageView.setAsDefault.tooltip'
  | 'cairo.archivedFields.back.custom-columns.tooltip'
  | 'cairo.tags.collectionPage.popover.search.placeholder'
  | 'cairo.export.sessionExpiredMessage'
  | 'cairo.tags.collectionPage.applyChanges.CTA'
  | 'cairo.filterOperator.greaterThan'
  | 'cairo.customFields.addCustomField.modal.fieldName.placeholder'
  | 'cairo.customFields.entityPage.sectionTitle'
  | 'cairo.table.listView'
  | 'cairo.tags.manageTags.modal.emptyState.title.asLabels'
  | 'cairo.passiveEmptyState.subtitle'
  | 'cairo.filtersPanel.date.to.clearButton.ariaLabel'
  | 'cairo.customFields.tpaSection.tooltip'
  | 'cairo.tags.collectionPage.popover.loadTags.error.body'
  | 'cairo.table.advanced-sorting.button.cta'
  | 'cairo.emptyState.premium.cta'
  | 'cairo.tags.applyChanges.toast.success.asLabels'
  | 'cairo.collectionPage.nested.collapseAll.tooltip'
  | 'cairo.manageView.Rename.disabled.predefinedView.tooltip'
  | 'cairo.customFields.addCustomField.modal.fieldType.placeholder'
  | 'cairo.import.continue'
  | 'cairo.customFields.fieldType.checkbox.Name.placeholder'
  | 'cairo.import.import'
  | 'cairo.tags.collectionPage.tagsColumn.manage.CTA.asLabels'
  | 'cairo.tags.manageTags.modal.add.CTA'
  | 'cairo.entityPage.widgetError.TPAconnectionFail.title'
  | 'cairo.error.tryAgain.cta'
  | 'cairo.tags.filterPanel.dropdown.placeholder'
  | 'cairo.customFields.fieldType.date.Name.placeholder'
  | 'cairo.customFields.addCustomField.dropdownList.emptyFieldName.error'
  | 'cairo.customFields.addCustomField.modal.advancedSettings.externalApps'
  | 'cairo.export.successMessage'
  | 'cairo.import.skipImportedItems'
  | 'cairo.downloadable-url.error.generic'
  | 'cairo.table.custom-columns.indication.user.tooltip'
  | 'cairo.table.mobile.more.button'
  | 'cairo.editableTable.contextMenu.deleteRows.someNotDeletable.tooltip'
  | 'cairo.customFields.entityPage.subtitle'
  | 'cairo.dropdownSearch.filters.emptyState'
  | 'cairo.customFields.createDataExtension.fqdn-not-extensible.error'
  | 'cairo.tags.fqdn-not-found.manageTagsModal.error'
  | 'cairo.editableTable.deleteItem.error.toast'
  | 'cairo.setupWidget.step.lockedTooltip'
  | 'cairo.import.title'
  | 'cairo.dragAndDrop.note'
  | 'cairo.tags.tagsWidget.add.CTA.asLabels'
  | 'cairo.filtersPanel.date.from.placeholder'
  | 'cairo.editableTable.createItem.error.toast'
  | 'cairo.import.summaryUpdated'
  | 'cairo.import.missingRequiredMessage'
  | 'cairo.tags.manageTags.modal.deleteModal.body.asLabels'
  | 'cairo.filtersPanel.numRange.maxRange.consumer.error'
  | 'cairo.bulkSelectedWithTotal'
  | 'cairo.import.newFieldOption'
  | 'cairo.setupWidget.progress.label'
  | 'cairo.search.Tab.noresults.title'
  | 'cairo.fieldValidation.charactersLimit.outOfBounds.error'
  | 'cairo.manageView.setAsDefault.error.toast'
  | 'cairo.deleteSuccess'
  | 'cairo.import.partialSuccess'
  | 'cairo.saveView.Success.toast'
  | 'cairo.customFields.fieldType.date.invalid.value'
  | 'cairo.customFields.maxFields.tooltip'
  | 'cairo.bulkActions.max.selection'
  | 'cairo.customFields.delete.modal.title'
  | 'cairo.customFields.deleted.success.toast'
  | 'cairo.collectionPage.nestedLimit.tooltip'
  | 'cairo.tags.manageTags.modal.list.create.CTA'
  | 'cairo.import.summaryCreated'
  | 'cairo.customFields.archive.modal.title.enabled'
  | 'cairo.editableTable.contextMenu.deleteRow.CTA'
  | 'cairo.import.partialSuccessToast'
  | 'cairo.settings.search.anchor-doesnt-exist.error'
  | 'cairo.tags.creationLimitReached.error.asLabels'
  | 'cairo.editableTable.field.validation.required'
  | 'cairo.emptyState.subtitle.nothingMatches'
  | 'cairo.customFields.restore.error.toast'
  | 'cairo.editableTable.updateItem.success.toast'
  | 'cairo.sortableColumns.modal.title'
  | 'cairo.table.deleteViewModal.deleteBody'
  | 'cairo.table.summaryBar.list.item'
  | 'cairo.customFields.delete.modal.description'
  | 'cairo.bulkSelected'
  | 'cairo.tags.collectionPage.popover.create.CTA.asLabels'
  | 'cairo.tags.manageTags.modal.title.asLabels'
  | 'cairo.fieldValidation.maxCharacter'
  | 'cairo.picker.itemsSelected'
  | 'cairo.filtersPanel.numRange.minRange.consumer.error'
  | 'cairo.tags.manageTags.modal.list.create.CTA.asLabels'
  | 'cairo.manageView.Rename.Success.toast'
  | 'cairo.tags.creationLimitReached.error'
  | 'cairo.fieldValidation.minCharacter'
  | 'cairo.appliedFilters'
  | 'cairo.tags.bulkItemUpdate.toast.error.asLabels'
  | 'cairo.fieldValidation.minNumber'
  | 'cairo.setupWidget.aggregated.counter'
  | 'cairo.bulkSelected.selectUpTo'
  | 'cairo.tags.manageTags.modal.deleteModal.body'
  | 'cairo.tags.manageTags.modal.title'
  | 'cairo.sortableColumns.modal.description'
  | 'cairo.deleteView.Success.toast'
  | 'cairo.entity.item'
  | 'cairo.import.summaryFailed'
  | 'cairo.manageView.saveChanges.Success.toast'
  | 'cairo.search.nothingMatches.title'
  | 'cairo.editableTable.deleteItem.success.toast'
  | 'cairo.dragAndDrop.live-region.itemDragged.sr'
  | 'cairo.editableTable.field.validation.pattern'
  | 'cairo.import.summaryCounts'
  | 'cairo.import.newFieldHelper'
  | 'cairo.tags.manageTags.modal.list.input.validation.maxLength'
  | 'cairo.selector.modal.items.selected'
  | 'cairo.import.missingRequiredField'
  | 'cairo.tags.manageTags.modal.list.input.validation.maxLength.asLabels'
  | 'cairo.selected'
  | 'cairo.editableTable.contextMenu.clearCell.CTA'
  | 'cairo.filtersPanel.search.noResults.title'
  | 'cairo.sortableColumns.notification'
  | 'cairo.tags.popover.creationLimitReached.error.asLabels'
  | 'cairo.import.summaryErrorRow'
  | 'cairo.editableTable.field.validation.specificValues'
  | 'cairo.tags.popover.creationLimitReached.error'
  | 'cairo.fieldValidation.maxNumber'
  | 'cairo.customFields.archive.success.toast.enabled'
  | 'cairo.customFields.restored.success.toast'
  | 'cairo.appliedFilters.selected'
  | 'cairo.editableTable.contextMenu.removeRows.CTA'
  | 'cairo.customFields.delete.error.toast'
  | 'cairo.tags.collectionPage.popover.create.CTA'
  | 'cairo.import.fileNameLabel'
  | 'cairo.tags.bulkItemUpdate.toast.error'
  | 'cairo.dragAndDrop.button-role-label.sr'
  | 'cairo.dropdownSearch.filters.selected'
  | 'cairo.tags.tagsWidget.options.add.CTA'
  | 'cairo.customFields.archive.error.toast'
  | 'cairo.a11y.liveRegion.resultsFound'
  | 'cairo.dragAndDrop.live-region.itemDropped.sr'
  | 'cairo.manageView.setAsDefault.success.toast'
  | 'cairo.filtersPanel.appliedFilters.label'
  | 'cairo.tags.tagsWidget.options.add.CTA.asLabels';

export type Translate = {
  (key: TranslationsKeys, params?: Record<string, string | number>): string;
  (key: 'cairo.import.summaryUpdated', params: { count: number }): string;
  (
    key: 'cairo.import.missingRequiredMessage',
    params: { fields: string },
  ): string;
  (
    key: 'cairo.tags.manageTags.modal.deleteModal.body.asLabels',
    params: { name: string },
  ): string;
  (
    key: 'cairo.filtersPanel.numRange.maxRange.consumer.error',
    params: { maxAmount: number },
  ): string;
  (
    key: 'cairo.bulkSelectedWithTotal',
    params: { num: number; total: number },
  ): string;
  (key: 'cairo.import.newFieldOption', params: { column: string }): string;
  (
    key: 'cairo.setupWidget.progress.label',
    params: { completed: string; total: number },
  ): string;
  (
    key: 'cairo.search.Tab.noresults.title',
    params: { tabName: string },
  ): string;
  (
    key: 'cairo.fieldValidation.charactersLimit.outOfBounds.error',
    params: { min: number; max: number },
  ): string;
  (
    key: 'cairo.manageView.setAsDefault.error.toast',
    params: { viewName: string },
  ): string;
  (key: 'cairo.deleteSuccess', params: { itemName: string }): string;
  (
    key: 'cairo.import.partialSuccess',
    params: { succeeded: string; failed: string },
  ): string;
  (key: 'cairo.saveView.Success.toast', params: { viewName: string }): string;
  (
    key: 'cairo.customFields.fieldType.date.invalid.value',
    params: { dateFormat: string },
  ): string;
  (
    key: 'cairo.customFields.maxFields.tooltip',
    params: { max: number },
  ): string;
  (
    key: 'cairo.bulkActions.max.selection',
    params: { total: number; max: number },
  ): string;
  (
    key: 'cairo.customFields.delete.modal.title',
    params: { selectedField: string },
  ): string;
  (
    key: 'cairo.customFields.deleted.success.toast',
    params: { selectedField: string },
  ): string;
  (
    key: 'cairo.collectionPage.nestedLimit.tooltip',
    params: { subCatsAmount: number },
  ): string;
  (
    key: 'cairo.tags.manageTags.modal.list.create.CTA',
    params: { tagName: string },
  ): string;
  (key: 'cairo.import.summaryCreated', params: { count: number }): string;
  (
    key: 'cairo.customFields.archive.modal.title.enabled',
    params: { selectedField: string },
  ): string;
  (
    key: 'cairo.editableTable.contextMenu.deleteRow.CTA',
    params: { count: number },
  ): string;
  (
    key: 'cairo.import.partialSuccessToast',
    params: { failed: string; imported: string },
  ): string;
  (
    key: 'cairo.settings.search.anchor-doesnt-exist.error',
    params: { anchorName: string },
  ): string;
  (
    key: 'cairo.tags.creationLimitReached.error.asLabels',
    params: { limit: string; count: number },
  ): string;
  (
    key: 'cairo.editableTable.field.validation.required',
    params: { fieldName: string },
  ): string;
  (
    key: 'cairo.emptyState.subtitle.nothingMatches',
    params: { term: string },
  ): string;
  (
    key: 'cairo.customFields.restore.error.toast',
    params: { selectedField: string },
  ): string;
  (
    key: 'cairo.editableTable.updateItem.success.toast',
    params: { count: number },
  ): string;
  (
    key: 'cairo.sortableColumns.modal.title',
    params: { columnTitle: string },
  ): string;
  (
    key: 'cairo.table.deleteViewModal.deleteBody',
    params: { viewName: string },
  ): string;
  (
    key: 'cairo.table.summaryBar.list.item',
    params: { title: string; value: string },
  ): string;
  (
    key: 'cairo.customFields.delete.modal.description',
    params: { selectedField: string },
  ): string;
  (key: 'cairo.bulkSelected', params: { num: number }): string;
  (
    key: 'cairo.tags.collectionPage.popover.create.CTA.asLabels',
    params: { tagName: string },
  ): string;
  (
    key: 'cairo.tags.manageTags.modal.title.asLabels',
    params: { EntityName: string },
  ): string;
  (
    key: 'cairo.fieldValidation.maxCharacter',
    params: { charMax: number },
  ): string;
  (
    key: 'cairo.picker.itemsSelected',
    params: { total: number; max: number },
  ): string;
  (
    key: 'cairo.filtersPanel.numRange.minRange.consumer.error',
    params: { minAmount: number },
  ): string;
  (
    key: 'cairo.tags.manageTags.modal.list.create.CTA.asLabels',
    params: { tagName: string },
  ): string;
  (
    key: 'cairo.manageView.Rename.Success.toast',
    params: { oldViewName: string; newViewName: string },
  ): string;
  (
    key: 'cairo.tags.creationLimitReached.error',
    params: { limit: string; count: number },
  ): string;
  (
    key: 'cairo.fieldValidation.minCharacter',
    params: { charMin: number },
  ): string;
  (key: 'cairo.appliedFilters', params: { num: number }): string;
  (
    key: 'cairo.tags.bulkItemUpdate.toast.error.asLabels',
    params: { total: number },
  ): string;
  (
    key: 'cairo.fieldValidation.minNumber',
    params: { minAmount: number },
  ): string;
  (
    key: 'cairo.setupWidget.aggregated.counter',
    params: { completed: string; total: number },
  ): string;
  (key: 'cairo.bulkSelected.selectUpTo', params: { max: number }): string;
  (
    key: 'cairo.tags.manageTags.modal.deleteModal.body',
    params: { name: string },
  ): string;
  (
    key: 'cairo.tags.manageTags.modal.title',
    params: { EntityName: string },
  ): string;
  (
    key: 'cairo.sortableColumns.modal.description',
    params: { columnTitle: string },
  ): string;
  (key: 'cairo.deleteView.Success.toast', params: { viewName: string }): string;
  (key: 'cairo.entity.item', params: { num: number }): string;
  (key: 'cairo.import.summaryFailed', params: { count: number }): string;
  (
    key: 'cairo.manageView.saveChanges.Success.toast',
    params: { viewName: string },
  ): string;
  (key: 'cairo.search.nothingMatches.title', params: { term: string }): string;
  (
    key: 'cairo.editableTable.deleteItem.success.toast',
    params: { count: number },
  ): string;
  (
    key: 'cairo.dragAndDrop.live-region.itemDragged.sr',
    params: { currentNumber: number; totalNumber: number },
  ): string;
  (
    key: 'cairo.editableTable.field.validation.pattern',
    params: { fieldName: string },
  ): string;
  (
    key: 'cairo.import.summaryCounts',
    params: { succeeded: string; failed: string },
  ): string;
  (key: 'cairo.import.newFieldHelper', params: { typeName: string }): string;
  (
    key: 'cairo.tags.manageTags.modal.list.input.validation.maxLength',
    params: { count: number },
  ): string;
  (
    key: 'cairo.selector.modal.items.selected',
    params: { total: number },
  ): string;
  (key: 'cairo.import.missingRequiredField', params: { count: number }): string;
  (
    key: 'cairo.tags.manageTags.modal.list.input.validation.maxLength.asLabels',
    params: { count: number },
  ): string;
  (key: 'cairo.selected', params: { total: number }): string;
  (
    key: 'cairo.editableTable.contextMenu.clearCell.CTA',
    params: { count: number },
  ): string;
  (
    key: 'cairo.filtersPanel.search.noResults.title',
    params: { term: string },
  ): string;
  (
    key: 'cairo.sortableColumns.notification',
    params: { columnTitle: string },
  ): string;
  (
    key: 'cairo.tags.popover.creationLimitReached.error.asLabels',
    params: { limit: string; count: number },
  ): string;
  (
    key: 'cairo.import.summaryErrorRow',
    params: { row: string; message: string },
  ): string;
  (
    key: 'cairo.editableTable.field.validation.specificValues',
    params: { fieldName: string },
  ): string;
  (
    key: 'cairo.tags.popover.creationLimitReached.error',
    params: { limit: string; count: number },
  ): string;
  (
    key: 'cairo.fieldValidation.maxNumber',
    params: { maxAmount: number },
  ): string;
  (
    key: 'cairo.customFields.archive.success.toast.enabled',
    params: { selectedField: string },
  ): string;
  (
    key: 'cairo.customFields.restored.success.toast',
    params: { selectedField: string },
  ): string;
  (key: 'cairo.appliedFilters.selected', params: { num: number }): string;
  (
    key: 'cairo.editableTable.contextMenu.removeRows.CTA',
    params: { count: number },
  ): string;
  (
    key: 'cairo.customFields.delete.error.toast',
    params: { selectedField: string },
  ): string;
  (
    key: 'cairo.tags.collectionPage.popover.create.CTA',
    params: { tagName: string },
  ): string;
  (key: 'cairo.import.fileNameLabel', params: { name: string }): string;
  (
    key: 'cairo.tags.bulkItemUpdate.toast.error',
    params: { total: number },
  ): string;
  (
    key: 'cairo.dragAndDrop.button-role-label.sr',
    params: { itemName: string },
  ): string;
  (
    key: 'cairo.dropdownSearch.filters.selected',
    params: { total: number },
  ): string;
  (
    key: 'cairo.tags.tagsWidget.options.add.CTA',
    params: { tagName: string },
  ): string;
  (
    key: 'cairo.customFields.archive.error.toast',
    params: { selectedField: string },
  ): string;
  (key: 'cairo.a11y.liveRegion.resultsFound', params: { num: number }): string;
  (
    key: 'cairo.dragAndDrop.live-region.itemDropped.sr',
    params: { currentNumber: number },
  ): string;
  (
    key: 'cairo.manageView.setAsDefault.success.toast',
    params: { viewName: string },
  ): string;
  (
    key: 'cairo.filtersPanel.appliedFilters.label',
    params: { numberAppliedFilters: number },
  ): string;
  (
    key: 'cairo.tags.tagsWidget.options.add.CTA.asLabels',
    params: { tagName: string },
  ): string;
};
